import React from 'react'
import './FinanceDashboardCardStyle.css'

function FinanceDashboardCard({ color1 = "#9575CD", color2 = '#A67DFF', title, count, icon, subTitle }) {
    return (
        <div className='finance_dc_container' style={{ background: `linear-gradient(to right, ${color1}, ${color2})` }}>
            <div className='finance_dc_layout'>
                <div className='finance_dc_top_section'>
                    <span className='finance_dc_title_1'>{title}</span>

                    <div className='finance_dashboard_icon_section'>
                        <span className='finance_dashboard_icon_style'>{icon}</span>
                    </div>
                </div>
                <div className='finance_dc_top_section'>
                    <span className='finance_dc_title_2'>{count}</span>
                    <span className='finance_dc_sub_title_2'>{subTitle}</span>
                </div>
            </div>
        </div>
    )
}

export default FinanceDashboardCard
